// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"516":"5d97263e","850":"fe0fefb3"}[chunkId] + ".chunk.js";
};